const TEMPLATE_NAME = 'CLINICAL_EVOLUTION_PEP';

const initialState = () => ({
  loading: false,
  loadedData: [],
  filter: {
    term: '',
    data: []
  }
});

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${TEMPLATE_NAME}_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }
    case `${TEMPLATE_NAME}_REJECTED`: {
      return {
        ...state,
        loading: false
      };
    }
    case `${TEMPLATE_NAME}_FULFILLED`: {
      const currentData = state.loadedData;
      const newData = action.payload;
      return {
        ...state,
        loading: false,
        loadedData: [...currentData, ...newData],
        filter: {
          ...state.filter,
          data: [...state.loadedData, ...newData]
        }
      };
    }

    case `${TEMPLATE_NAME}_PERPAGE_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }

    case `${TEMPLATE_NAME}_PERPAGE_REJECTED`: {
      return {
        ...state,
        loading: false
      };
    }

    case `${TEMPLATE_NAME}_PERPAGE_FULFILLED`: {
      const currentData = state.filter.data;
      const newData = action.payload;
      return {
        ...state,
        loading: false,
        loadedData: [...currentData, ...newData],
        filter: {
          ...state.filter,
          data: [...state.loadedData, ...newData]
        }
      };
    }
    case `${TEMPLATE_NAME}_SEARCH_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }

    case `${TEMPLATE_NAME}_SEARCH_REJECTED`: {
      return {
        ...state,
        loading: false
      };
    }

    case `${TEMPLATE_NAME}_SEARCH_FULFILLED`: {
      const newData = action.payload;

      return {
        ...state,
        loading: false,
        loadedData: newData,
        filter: {
          ...state.filter,
          data: newData
        }
      };
    }

    // case `${TEMPLATE_NAME}_UPDATE`: {
    //     const updatedRow = action.payload;
    //     const loadedData = state.loadedData.map(row =>
    //         row.id === updatedRow.id ? updatedRow : row
    //     );

    //     return {
    //         ...state,
    //         loadedData,
    //         filter: {
    //             ...state.filter,
    //             data: filterData(loadedData, state.filter.term),
    //         },
    //     };
    // }
    // case `${TEMPLATE_NAME}_DELETE`: {
    //     const deletedId = action.payload;
    //     const data = state.data.filter(data => data.id !== deletedId);

    //     return {
    //         ...state,
    //         loading: false,
    //         data,
    //         filter: {
    //             ...state.filter,
    //             data: filterData(data, state.filter.term, state.filter.type),
    //         },
    //     };
    // }

    // case `${TEMPLATE_NAME}_CREATE`: {
    //     const newRow = action.payload;
    //     const data = [...state.loadedData, newRow];
    //     return {
    //         ...state,
    //         loading: false,
    //         data,
    //         filter: {
    //             ...state.filter,
    //             data: filterData(data, state.filter.term, state.filter.type),
    //         },
    //     };
    // }
    case `${TEMPLATE_NAME}_RESET`: {
      return initialState();
    }
    default:
      return state;
  }
};

export default reducer;
